// DataValidationLegend.js
import React from "react";

const DataValidationLegend = ({ fontFamily }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        justifyContent: "left",
        gap: "15px",
        marginTop: "10px",
        marginBottom: "10px",
        marginTop: "auto",
        //   padding: '10px',
        borderRadius: "4px",
        fontSize: "12px",
        fontFamily: fontFamily,
        alignItems: "left",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ color: "green", marginRight: "5px", fontSize: "14px" }}>✓</span>
        <span>Data matching in both withholding statement and form</span>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: "14px",
            height: "14px",
            border: "1px solid #ccc",
            marginRight: "5px",
            backgroundColor: "#f8d7da",
          }}
        ></div>
        <span>Mandatory data missing</span>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: "14px",
            height: "14px",
            backgroundColor: "red",
            marginRight: "5px",
          }}
        ></div>
        <span>Data value doesn't match in our system</span>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: "14px",
            height: "14px",
            backgroundColor: "#FFD580",
            marginRight: "5px",
          }}
        ></div>
        <span>Data added via form extraction</span>
      </div>
    </div>
  );
};

export default DataValidationLegend;
